import NextLink from 'next/link';
import { twJoin } from 'tailwind-merge';

import Anchor from 'components/Anchor';
import UserAvatar from 'components/UserAvatar';

import { toUserProfileLink } from 'lib/links';

import { useUser } from 'providers/UserProvider';

const TextEditorUserAvatar = ({ className }) => {
  const { isLoggedIn, LoggedInUser } = useUser();

  if (!isLoggedIn) {
    return (
      <UserAvatar
        className={className}
        description="Usuário deslogado"
        size="size5"
        userLevel={0}
      />
    );
  }

  return (
    <NextLink
      href={toUserProfileLink(LoggedInUser.userUsername)}
      prefetch={false}
      passHref
    >
      <Anchor className={twJoin('h-fit', className)}>
        <UserAvatar
          size="size5"
          userLevel={LoggedInUser.userLevel}
          userName={LoggedInUser.userName}
          userPhoto={LoggedInUser.userPhoto}
          userTypeName={LoggedInUser.userTypeName}
        />
      </Anchor>
    </NextLink>
  );
};

export default TextEditorUserAvatar;
